import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";

import { fetchAllLeadRemindersQueryOptions } from "@/config/queries/emp-query-options";
import { useMemo } from "react";
import { DataTable } from "./_components/lead-reminders-table/data-table";
import { getColumns } from "./_components/lead-reminders-table/columns";
import { LeadReminder } from "./_components/lead-reminders-table/schema";
import { ColumnDef } from "@tanstack/react-table";
import { DisableLeadReminderModal } from "./_components/disable-reminder-action/take-action-modal";

const LeadRemindersForEmployee = () => {
  const key = Cookies.get("key") as string;

  const { data, isPending, isFetching } = useQuery(
    fetchAllLeadRemindersQueryOptions(key)
  );

  const leadTriggers = useMemo(() => {
    if (isPending) {
      return [];
    }

    if (data === undefined || data?.triggers === undefined) {
      return [];
    }

    const result = data?.triggers?.map((trigger) => {
      return {
        id: trigger?._id,
        comments: trigger?.comments,
        createdAt: trigger?.createdAt,
        disabled: trigger?.disabled,
        triggered: trigger?.triggered,
        lead: trigger?.lead,
      };
    });

    return result?.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }, [data, isPending, isFetching]);

  const columns = useMemo<ColumnDef<LeadReminder, unknown>[]>(
    () => getColumns(),
    []
  );

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Lead Reminders</h3>
      </div>

      <div className="mt-3">
        <DataTable columns={columns} data={leadTriggers} />
      </div>

      <DisableLeadReminderModal />
    </div>
  );
};

export default LeadRemindersForEmployee;
